import React from 'react';
import SelectGameModeContainer from '../SelectGameModeContainer/SelectGameModeContainer';

const GameBgContainer: React.FC = () => {
  return <SelectGameModeContainer />;
};

export default GameBgContainer;
